import { forwardRef, type HTMLProps } from 'react';

export const TableBody = forwardRef<
  HTMLTableSectionElement,
  Omit<HTMLProps<HTMLTableSectionElement>, 'className'>
>((props, ref) => {
  return <tbody {...props} className="text-body-md" ref={ref} />;
});

TableBody.displayName = 'TableBody';
